module.exports = __webpack_public_path__ + "static/img/ent-detail-43.337194d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-43.jpg
// module id = TT8E
// module chunks = 52